import React from "react";
import PageHeader from "../../components/pageheader/pageHeader";
import "./pageWrapper.css";

class PageWrapper extends React.PureComponent {
  render() {
    const { children, customClass = "" } = this.props;
    return (
      <div className={`container-fluid page-wrapper clearfix ${customClass}`} id="page-wrapper">
        {children}
      </div>
    );
  }
}

function PageWrapperHeader(props) {
  const { children } = props;
  return <PageHeader {...props}>{children}</PageHeader>;
}
PageWrapper.Header = PageWrapperHeader;

function PageBodyWrapper(props) {
  const { children, customClass = "" } = props;
  return (
    <div className={`body-wrapper ${customClass}`} {...props}>
      {children}
    </div>
  );
}
PageWrapper.Body = PageBodyWrapper;

function PageWrapperBodyHeader(props) {
  const { children } = props;
  return (
    <div className="row filter-wrapper">
      <div className="col-sm-12">{children}</div>
    </div>
  );
}
PageWrapper.BodyHeader = PageWrapperBodyHeader;

export default PageWrapper;
